import axios from 'axios';
import makeApiRoute from '../utils/apiRoute';
import { IState } from '../components/Calculator'

export class CalculatorService {

   public static submit(apiKey: string, data: IState) {
      return axios.post(makeApiRoute(`/calculator/${apiKey}/submit`), data);
   }

}
